export default __webpack_public_path__ + "static/media/modal-close.45397302.svg";